import { render, staticRenderFns } from "./RibList.vue?vue&type=template&id=647765dc&"
import script from "./RibList.vue?vue&type=script&lang=js&"
export * from "./RibList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports